/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-anonymous-default-export */
import React, { useEffect, useState, useRef } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import "./searchBox.css";
import { components } from "react-select";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

// Base64 Search Icon
const searchIconBase64 =
  "data:image/png;base64,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";

// Custom DropdownIndicator with MUI icon
const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <ArrowDropDownIcon sx={{ color: "#74b44a", fontSize: "24px" }} />
    </components.DropdownIndicator>
  );
};

// Custom Control component with search icon
const Control = ({ children, ...props }) => (
  <components.Control {...props}>
    <img
      src={searchIconBase64}
      alt="search"
      style={{
        width: "25px",
        height: "25px",
        marginLeft: "10px",
        marginRight: "5px",
      }}
    />
    {children}
  </components.Control>
);

// Custom Input component that maintains focus
const CustomInput = (props) => {
  return <components.Input {...props} />;
};

// Custom Menu component that doesn't steal focus
const CustomMenu = (props) => {
  return (
    <components.Menu {...props}>
      <div onMouseDown={(e) => e.preventDefault()}>{props.children}</div>
    </components.Menu>
  );
};

// Custom Option component that doesn't take focus
const CustomOption = (props) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseDown={(e) => {
        e.preventDefault();
        props.selectOption(props.data);
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        ...props.getStyles("option", props),
        backgroundColor: isHovered ? "#e8f9d2" : "white",
        cursor: "pointer",
      }}
    >
      {props.children}
    </div>
  );
};

export default function SearchDropdown(props) {
  const [value, onChange] = useState(
    props.defaultVal
      ? {
          value: props.defaultVal,
          label: props.defaultVal,
        }
      : props.value || null
  );

  const selectRef = useRef(null);

  const {
    apiCall,
    saveProp,
    showProp,
    placeHolder,
    onSelect,
    complicated,
    getAllData,
    disabled,
    setSampleTypesData,
    setSampleInfoLabel,
    menuPortalTarget,
    menuPosition = "absolute",
    customStyles = {},
    localData,
    forceUpdateKey,
    apiParams = [],
  } = props;

  const [fullData, setFullData] = useState(null);

  // Update internal value state when props.value changes
  useEffect(() => {
    onChange(props.value || null);
  }, [props.value]);

  // Update value when defaultVal changes
  useEffect(() => {
    if (props.defaultVal) {
      onChange({
        value: props.defaultVal,
        label: props.defaultVal,
      });
    }
  }, [props.defaultVal]);

  // Reset value when forceUpdateKey changes
  useEffect(() => {
    if (forceUpdateKey !== undefined) {
      onChange(
        props.defaultVal
          ? {
              value: props.defaultVal,
              label: props.defaultVal,
            }
          : null
      );
    }
  }, [forceUpdateKey]);

  async function loadOptions(search, loadedOptions, { page }) {
    // Handle local data mode
    if (localData) {
      const options = localData.map((item) => ({
        value: item[saveProp] || item.id || item.value,
        label: item[showProp?.[0]] || item.name || item.label,
      }));

      return {
        options: options,
        hasMore: false,
      };
    }

    // Handle API call mode
    var val = [];
    var totalpage = { current_page: null, last_page: null };

    // Build API call parameters: [...apiParams, search, page]
    const apiCallParams = Array.isArray(apiParams)
      ? [...apiParams, search, page]
      : [search, page];

    await apiCall(...apiCallParams)
      .then((x) => {
        console.log(x.data);
        // Store full API response for additional callbacks
        setFullData(x);
        totalpage = {
          current_page: x.data.current_page,
          last_page: x.data.last_page,
        };
        console.log(x.data.last_page);
        val = x.data.data.map((d) => {
          let temp = "";
          if (!complicated) {
            showProp.forEach((element) => {
              temp = temp + d[element] + " ";
            });
          } else {
            temp = d.name + " - " + d.test.name;
          }
          return {
            value: getAllData ? d : d[saveProp],
            label: temp,
          };
        });
      })
      .catch((err) => {
        console.log(err);
        val = [];
      });
    let filteredOptions;

    if (!search) {
      filteredOptions = val;
    } else {
      const searchLower = search.toLowerCase();
      filteredOptions = val.filter(({ label }) =>
        label.toLowerCase().includes(searchLower)
      );
    }

    const hasMore =
      totalpage?.current_page >= totalpage?.last_page ? false : true;
    console.log(totalpage, "pages");
    return {
      options: filteredOptions || [],
      hasMore: hasMore,
      additional: {
        page: page + 1,
      },
    };
  }

  const handleChange = (val) => {
    onChange(val);
    if (onSelect) {
      onSelect(val);
    }

    // Handle additional callbacks if provided
    if (val && fullData && setSampleTypesData && setSampleInfoLabel) {
      const selectedItem = fullData.data.data.find(
        (item) => item.id === val.value
      );
      if (selectedItem) {
        setSampleTypesData(selectedItem.test_samples);
        setSampleInfoLabel(selectedItem.sample_info);
      }
    }
  };

  const themeStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "54px",
      height: "54px",
      borderColor: state.isDisabled ? "#d0d4d1" : "#74b44a",
      borderWidth: "1px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#74b44a",
      },
      borderRadius: "8px",
      cursor: "text",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "54px",
      padding: "0 8px",
    }),
    input: (base) => ({
      ...base,
      margin: "0",
      padding: "0",
      color: "#2f481e",
      fontSize: "15px",
      fontWeight: "700 !important",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#84857a",
      fontSize: "15px",
      fontStyle: "italic !important",
      fontWeight: "700 !important",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#2f481e",
      fontSize: "15px",
      fontWeight: "700 !important",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      border: "1px solid #e7ece8",
      marginTop: "4px",
    }),
    menuList: (base) => ({
      ...base,
      padding: "4px",
      borderRadius: "8px",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: "white",
      color: "#2f481e",
      padding: "12px 16px",
      cursor: "pointer",
      fontSize: "15px",
      fontWeight: "500",
      borderRadius: "6px",
      marginBottom: "2px",
      "&:hover": {
        backgroundColor: "white",
      },
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: "none",
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: "#74b44a",
      padding: "0 12px",
      transition: "transform 0.2s",
      transform: state.selectProps.menuIsOpen
        ? "rotate(180deg)"
        : "rotate(0deg)",
      "&:hover": {
        color: "#57932f",
      },
    }),
    clearIndicator: (base) => ({
      ...base,
      color: "#84857a",
      padding: "0 8px",
      "&:hover": {
        color: "#b44a4a",
      },
    }),
    loadingIndicator: (base) => ({
      ...base,
      color: "#74b44a",
    }),
    noOptionsMessage: (base) => ({
      ...base,
      color: "#84857a",
      fontSize: "15px",
      padding: "12px",
    }),
    loadingMessage: (base) => ({
      ...base,
      color: "#84857a",
      fontSize: "15px",
      padding: "12px",
    }),
    ...customStyles,
  };

  const mergedStyles = menuPortalTarget
    ? {
        ...themeStyles,
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
          ...customStyles.menuPortal,
        }),
      }
    : themeStyles;

  return (
    <div className="search-dropdown-wrapper">
      <AsyncPaginate
        ref={selectRef}
        styles={mergedStyles}
        isClearable={true}
        components={{
          Control,
          DropdownIndicator,
          Input: CustomInput,
          Menu: CustomMenu,
          Option: CustomOption,
        }}
        debounceTimeout={1000}
        value={value}
        loadOptions={loadOptions}
        onChange={handleChange}
        placeholder={placeHolder}
        additional={{
          page: 1,
        }}
        isDisabled={disabled}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPosition}
        key={forceUpdateKey}
        openMenuOnFocus={true}
        openMenuOnClick={true}
        blurInputOnSelect={false}
        closeMenuOnSelect={true}
        captureMenuScroll={false}
        tabSelectsValue={false}
      />
    </div>
  );
}
